export const FETCH_MOVIE_REQUEST = 'FETCH_MOVIE_REQUEST';
export const FETCH_MOVIE_SUCCESS = 'FETCH_MOVIE_SUCCESS';
export const FETCH_MOVIE_FAILURE = 'FETCH_MOVIE_FAILURE';
export const MOVIE_RESET = 'MOVIE_RESET';

export const FETCH_MOVIES_REQUEST = 'FETCH_MOVIES_REQUEST';
export const FETCH_MOVIES_SUCCESS = 'FETCH_MOVIES_SUCCESS';
export const FETCH_MOVIES_FAILURE = 'FETCH_MOVIES_FAILURE';

export const FETCH_FAVORITES_MOVIES_SUCCESS = 'FETCH_FAVORITES_MOVIES_SUCCESS';
export const FETCH_FAVORITES_BY_ID_FAILURE = 'FETCH_FAVORITES_BY_ID_FAILURE';
export const FAVORITES_MOVIES_RESET = 'FAVORITES_MOVIES_RESET';

export const MOVIE_ADDED_TO_FAVORITES = 'MOVIE_ADDED_TO_FAVORITES';
export const MOVIE_DELETED_FROM_FAVORITES = 'MOVIE_DELETED_FROM_FAVORITES';

export const PREMIERE_ADDED_TO_FAVORITES = 'PREMIERE_ADDED_TO_FAVORITES';
export const PREMIERE_DELETED_FROM_FAVORITES = 'PREMIERE_DELETED_FROM_FAVORITES';

export const PREPARE_QUERY_STRING = 'PREPARE_QUERY_STRING';
export const UPDATE_QUERY_STRING = 'UPDATE_QUERY_STRING';
export const SELECTIVELY_CLEAR_QUERY_STRING = 'SELECTIVELY_CLEAR_QUERY_STRING';

export const UPDATE_SEARCH_FILTER = 'UPDATE_SEARCH_FILTER';
export const CLEAR_SEARCH_FILTER = 'CLEAR_SEARCH_FILTER';

